/**
 * Resolves the locale id used for date/number formatting from a ngx-translate language code.
 * Any language is supported by `Intl`; English and unknown/empty values fall back to the provided locale.
 */
export function getLocaleFromLang(lang: string | null | undefined, fallbackLocale = 'en-US'): string {
    const normalized = lang?.replace('_', '-').trim();
    if (!normalized || normalized.toLowerCase().split('-')[0] === 'en') {
        return fallbackLocale;
    }
    return normalized;
}
